import React, { useState } from 'react';

const IconAmbulance = ({
    size = 16,
    stroke = 2,
    color = "currentColor",
    hoverColor = "#1890ff",
    marginRight = 8
}) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            strokeWidth={stroke}
            fill={isHovered ? hoverColor : color}
            stroke="none"
            style={{
                transition: "fill 0.3s ease",
                marginRight: `${marginRight}px`,
                marginLeft: "-4px",
                transform: "translateY(3px)", // <- aquí se baja
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <path d="M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
            <path d="M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
            <path d="M5 17h-2v-11a1 1 0 0 1 1 -1h9v12m-4 0h6m4 0h2v-6h-8m0 -5h5l3 5" />
            <path d="M6 10h4m-2 -2v4" />
        </svg>
    );
};

export default IconAmbulance;
